import * as CheckboxRadix from '@radix-ui/react-checkbox';
import { ComponentPropsWithoutRef, FC } from 'react';
import Checked from 'public/icons/checked.svg?react';
import {
  cvaCheckboxChecked,
  cvaCheckboxUnchecked,
  cvaCheckboxWrapper,
} from '~/shared/ui/Checkbox/CheckboxStyles';
import clsx from 'clsx';

//Контролируемая компонента. Стейт можно вынести наружу потом, тк в пропсах есть и checked и onCheckedChange.
//Можно обернуть в forwardRef по необходимости

interface Props extends ComponentPropsWithoutRef<typeof CheckboxRadix.Root> {
  label?: string;
  checked?: boolean;
  labelClass?: string;
  register?: any;
}

export const Checkbox: FC<Props> = ({
  checked,
  label,
  labelClass,
  className,
  ...rest
}) => {
  return (
    <div className={clsx(className, cvaCheckboxWrapper())}>
      <CheckboxRadix.Root
        {...rest}
        className={checked ? cvaCheckboxChecked() : cvaCheckboxUnchecked()}>
        <CheckboxRadix.Indicator>
          <Checked height={'2.4rem'} width={'2.4rem'} />
        </CheckboxRadix.Indicator>
      </CheckboxRadix.Root>
      {label && <label className={labelClass}>{label}</label>}
    </div>
  );
};

Checkbox.displayName = 'Checkbox';
